import React from 'react'
import { AppCardTitle, AppCrudTable, AppResultsSkeleton } from "@components"
import { useManageAdminStatusMultiple, useTable } from "Pages/Admin/GlobalExecution/Reports/@hooks"
import { executionDateColumn, progressBarColumn, reportNameColumn, runtimeColumn, sitesNameColumn, userNameColumn } from "./@columns"
import GlobalExecutionToolbarSelect from "Pages/Admin/GlobalExecution/Reports/Table/Toolbar"


export default function GlobalExecutionTable() {

	const { isTableLoading, tableReportData } = useTable()

	useManageAdminStatusMultiple()

	if (isTableLoading) return <AppResultsSkeleton/>

	return <AppCrudTable
		title={<AppCardTitle icon="file-lines" title="Global Executions"/>}
		columns={[reportNameColumn(), userNameColumn(), ...sitesNameColumn(), executionDateColumn(), runtimeColumn(), ...progressBarColumn()]}
		options={{
			selectableRows: 'multiple',
			customToolbarSelect: (selectedData, setSelectedRows) => <GlobalExecutionToolbarSelect
				selectedData={selectedData}
				setSelectedRows={setSelectedRows}/>
		}}
		data={tableReportData}
	/>
}